import hash from "object-hash";
const stringify = require("fast-json-stable-stringify");

export const getCacheKey = query => {
  const str = stringify(query);
  return hash(str);
};
